module.exports = __webpack_public_path__ + "img/devicethumb-sponsor.6b73003.svg";